import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchSemesters() {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/semesters`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.semesters.js
 **/